"use strict";

var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports.queryOne = exports.queryEl = exports.queryAncestor = exports.queryAll = exports["default"] = void 0;
var _queryFrom = _interopRequireWildcard(require("./queryFrom.js"));
exports.queryFrom = _queryFrom["default"];
_queryFrom.defaultQuery.from = _queryFrom["default"];
var _default = _queryFrom.defaultQuery;
exports["default"] = _default;
var queryAll = _queryFrom.defaultQuery.all,
  queryAncestor = _queryFrom.defaultQuery.ancestor,
  queryEl = _queryFrom.defaultQuery.el,
  queryOne = _queryFrom.defaultQuery.one;
exports.queryOne = queryOne;
exports.queryEl = queryEl;
exports.queryAncestor = queryAncestor;
exports.queryAll = queryAll;